import type { ReactNode } from "react";
import {
  SocialLinkButton,
  GoogleIcon,
  GitHubIcon,
  MicrosoftIcon,
  OktaIcon,
} from "@/components/sso-buttons";
import { getSsoLoginUrl, type SsoOauthProvider } from "@/src/services/auth_service";

type SsoChoice = {
  provider: SsoOauthProvider;
  name: string;
  icon: ReactNode;
};

const SOCIAL_PROVIDERS: SsoChoice[] = [
  { provider: "google", name: "Google", icon: <GoogleIcon /> },
  { provider: "microsoft", name: "Microsoft", icon: <MicrosoftIcon /> },
  { provider: "github", name: "GitHub", icon: <GitHubIcon /> },
];

const ENTERPRISE_PROVIDERS: SsoChoice[] = [
  { provider: "okta_enterprise", name: "Okta (Enterprise)", icon: <OktaIcon /> },
  { provider: "google_enterprise", name: "Google (Enterprise)", icon: <GoogleIcon /> },
];

const SOCIAL_BUTTON_CLASS = "flex-col gap-1.5 px-3 py-3";
const ENTERPRISE_BUTTON_CLASS = "gap-1.5 px-2 py-2.5 [&>img]:size-5";

export function SocialLogin({
  title = "Use one of these methods:",
  action = "Continue with",
}: {
  title?: string;
  action?: string;
}) {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-small font-medium text-grey-900">{title}</p>
      <div className="flex items-stretch gap-2">
        {SOCIAL_PROVIDERS.map(({ provider, name, icon }) => (
          <SocialLinkButton
            key={provider}
            aria-label={`${action} ${name}`}
            className={SOCIAL_BUTTON_CLASS}
            href={getSsoLoginUrl(provider)}
          >
            {icon}
            <span className="whitespace-nowrap text-tiny font-medium text-black">{name}</span>
          </SocialLinkButton>
        ))}
      </div>
      <div className="flex items-stretch gap-2">
        {ENTERPRISE_PROVIDERS.map(({ provider, name, icon }) => (
          <SocialLinkButton
            key={provider}
            className={ENTERPRISE_BUTTON_CLASS}
            href={getSsoLoginUrl(provider)}
          >
            {icon}
            <span className="whitespace-nowrap text-tiny font-medium text-black">{name}</span>
          </SocialLinkButton>
        ))}
      </div>
    </div>
  );
}
